<div class="update-password-container">
  <mat-card>
    <mat-card-title>{{ 'Update Password' | translate }}</mat-card-title>
    <mat-card-content>
      <form class="password-form" autocomplete="off" [formGroup]="form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'New Password' | translate }}</mat-label>
          <input matInput type="password" required formControlName="password" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'Confirm New Password' | translate }}</mat-label>
          <input
            matInput
            type="password"
            required
            formControlName="confirmPassword"
          />
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          class="submit-btn"
          (click)="changePassword()"
        >
          {{ 'Update Password' | translate }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
